import script from "./PartnerUserOnboardingForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./PartnerUserOnboardingForm.vue?vue&type=script&lang=ts&setup=true"

import "./PartnerUserOnboardingForm.vue?vue&type=style&index=0&id=7c64b13b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c64b13b"]])

export default __exports__